import { render, staticRenderFns } from "./UniversityCard.vue?vue&type=template&id=299cbd62&scoped=true&"
import script from "./UniversityCard.vue?vue&type=script&lang=js&"
export * from "./UniversityCard.vue?vue&type=script&lang=js&"
import style0 from "./UniversityCard.vue?vue&type=style&index=0&id=299cbd62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299cbd62",
  null
  
)

export default component.exports